import { useNavigate } from 'react-router-dom'
import { PendingInvoiceAlert } from '@/shared/components/ui/pending-invoice-alert'
import { routes } from '@/shared/constants'
import { useMyOrganization } from '../hooks/useMyOrganization'

/**
 * Banner global de factura pendiente. Lee `canCreateBusiness` de la query
 * `PortalMyOrganization` (cache compartido con el resto de la app).
 *
 * Se monta una sola vez en el shell autenticado y aparece sólo cuando hay org
 * y `canCreateBusiness === false`. El CTA navega al listado de facturas para
 * que el usuario complete el pago.
 */
export function PendingInvoiceBanner() {
  const navigate = useNavigate()
  const { organization, loading } = useMyOrganization()

  if (loading && !organization) return null
  if (!organization || organization.canCreateBusiness !== false) return null

  return (
    <div className="px-4 pt-4 md:px-8">
      <PendingInvoiceAlert onPay={() => navigate(routes.app.billing.list)} />
    </div>
  )
}
